export class SampleCommentDTO {
    comment: string;
    puid: string;
    status: string;
    timeStamp: Date;
}
export class RunCommentDTO {
    comment: string;
    puid: string;
    runId: string;
    status: string;
    timeStamp: Date;
}